import { FC } from "react";
import TemperatureSlider from "components/range-consumption/temperature-slider";
import AcSwitch from "components/range-consumption/ac-switch";
import { RangeSummary } from "components/range-consumption/range-summary";
import { Roads } from "components/range-consumption/roads";
import { Car, DrivingStyles, DrivingFactor, RoadsStatus } from "shared-types";
import {
  Wrapper,
  ConfigWrapper,
  AppContainer,
} from "components/styled-components/generic";
import DrivingStyle from "components/range-consumption/driving-style";
import { defaultCar } from "constants/cars";

interface RangePageProps {
  selectedModel: Car;
  isAcOn: boolean;
  setIsAcOn: (p: boolean) => void;
  temperature: number[];
  setTemperature: (p: number[]) => void;
  setCountryRoads: (p: RoadsStatus) => void;
  countryRoads: RoadsStatus;
  cityRoads: RoadsStatus;
  setCityRoads: (p: RoadsStatus) => void;
  highwayRoads: RoadsStatus;
  setHighwayRoads: (p: RoadsStatus) => void;
  range: number | null | undefined;
  usage: number | null | undefined;
  setDrivingStyle: (p: DrivingStyles) => void;
  drivingStyle: DrivingStyles;
  setDrivingFactor: (p: DrivingFactor) => void;
  drivingFactor: DrivingFactor;
}

export const RangePage: FC<RangePageProps> = ({
  selectedModel,
  isAcOn,
  setIsAcOn,
  temperature,
  setTemperature,
  setCountryRoads,
  countryRoads,
  cityRoads,
  setCityRoads,
  highwayRoads,
  setHighwayRoads,
  range,
  usage,
  setDrivingStyle,
  drivingStyle,
  setDrivingFactor,
  drivingFactor,
}) => {
  return (
    <AppContainer disabled={selectedModel?.id === defaultCar.id}>
      <Wrapper>
        <RangeSummary
          id={selectedModel.name}
          estimatedRange={range}
          estimatedUsage={usage}
        />
      </Wrapper>
      <ConfigWrapper>
        <div>
          <div>
            <TemperatureSlider
              setTemperature={setTemperature}
              temperature={temperature}
            />
          </div>
          <DrivingStyle
            setDrivingStyle={setDrivingStyle}
            drivingStyle={drivingStyle}
            setDrivingFactor={setDrivingFactor}
            drivingFactor={drivingFactor}
          />
        </div>
        <div>
          <Roads
            setCountryRoads={setCountryRoads}
            countryRoads={countryRoads}
            setHighwayRoads={setHighwayRoads}
            highwayRoads={highwayRoads}
            setCityRoads={setCityRoads}
            cityRoads={cityRoads}
          />
          <AcSwitch isAcOn={isAcOn} setIsAcOn={setIsAcOn} />
        </div>
      </ConfigWrapper>
    </AppContainer>
  );
};
